import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const EmailConfirm: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Cleanup localStorage when user closes/reloads the page
    const handleBeforeUnload = () => {
      localStorage.removeItem('registrationForm');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const handleBackToLogin = () => {
    // Clean localStorage before navigating
    localStorage.removeItem('registrationForm');
    navigate('/login');
  };

  return (
    <div className="w-full bg-white rounded-xl p-4 sm:p-8 lg:p-12 shadow-lg text-center">
      <div className="max-w-2xl mx-auto">
        {/* Icona di successo */}
        <div className="mb-4 sm:mb-6">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
            <svg
              className="w-8 h-8 sm:w-10 sm:h-10 text-green-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* Titolo */}
        <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold text-black mb-3 sm:mb-4">
          🎉 Registrazione completata!
        </h1>

        {/* Messaggio principale */}
        <p className="text-base sm:text-lg lg:text-xl text-gray-700 mb-4 sm:mb-6">
          Ti abbiamo inviato una <span className="text-fpcred font-semibold">email di conferma</span> per attivare il
          tuo account.
        </p>

        {/* Info aggiuntiva */}
        <div className="bg-fpcwhite rounded-lg p-3 sm:p-4 lg:p-6 mb-4 sm:mb-6">
          <p className="text-xs sm:text-sm lg:text-base text-gray-600">
            📧 Controlla la tua casella email e clicca sul link di conferma per iniziare a prenotare le tue lezioni.
          </p>
          <p className="text-xs sm:text-sm text-gray-500 mt-2">
            Non trovi l'email? Controlla nella cartella <strong>spam</strong> o <strong>promozioni</strong>.
          </p>
        </div>

        {/* Torna al login button */}
        <div className="mt-6 sm:mt-8">
          <button
            onClick={handleBackToLogin}
            className="px-6 py-3 bg-fpcred text-white font-semibold rounded-lg hover:bg-buttonhover transition-colors text-sm sm:text-base">
            Torna al login
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirm;
